var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmaverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11600_40132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11600_40132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50006 9.73752L3.00006 8.30002C2.84173 8.20835 2.71881 8.08752 2.63131 7.93752C2.54381 7.78752 2.50006 7.62085 2.50006 7.43752V4.56252C2.50006 4.37918 2.54381 4.21252 2.63131 4.06252C2.71881 3.91252 2.84173 3.79168 3.00006 3.70002L5.50006 2.26252C5.65839 2.17085 5.82506 2.12502 6.00006 2.12502C6.17506 2.12502 6.34173 2.17085 6.50006 2.26252L9.00006 3.70002C9.1584 3.79168 9.28131 3.91252 9.36881 4.06252C9.45631 4.21252 9.50006 4.37918 9.50006 4.56252V7.43752C9.50006 7.62085 9.45631 7.78752 9.36881 7.93752C9.28131 8.08752 9.1584 8.20835 9.00006 8.30002L6.50006 9.73752C6.34173 9.82918 6.17506 9.87502 6.00006 9.87502C5.82506 9.87502 5.65839 9.82918 5.50006 9.73752ZM5.50006 8.58752V6.28752L3.50006 5.12502V7.43752L5.50006 8.58752ZM6.50006 8.58752L8.50006 7.43752V5.12502L6.50006 6.28752V8.58752ZM1.00006 3.50002V2.00002C1.00006 1.72502 1.09798 1.4896 1.29381 1.29377C1.48964 1.09793 1.72506 1.00002 2.00006 1.00002H3.50006V2.00002H2.00006V3.50002H1.00006ZM3.50006 11H2.00006C1.72506 11 1.48964 10.9021 1.29381 10.7063C1.09798 10.5104 1.00006 10.275 1.00006 10V8.50002H2.00006V10H3.50006V11ZM8.50006 11V10H10.0001V8.50002H11.0001V10C11.0001 10.275 10.9021 10.5104 10.7063 10.7063C10.5105 10.9021 10.2751 11 10.0001 11H8.50006ZM10.0001 3.50002V2.00002H8.50006V1.00002H10.0001C10.2751 1.00002 10.5105 1.09793 10.7063 1.29377C10.9021 1.4896 11.0001 1.72502 11.0001 2.00002V3.50002H10.0001ZM6.00006 5.42502L7.97506 4.26252L6.00006 3.12502L4.02506 4.26252L6.00006 5.42502Z",
    fill: "#3B8EC0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmaverseIcon);
export default __webpack_public_path__ + "static/media/smaverseIcon.6fc303eafcb57344a61e48f1dee26de0.svg";
export { ForwardRef as ReactComponent };